import { useTranslation } from 'react-i18next';
import { TColor } from '../../type/color-type';
import { TIcons } from '../../type/icons-type';

export interface IEventStatus {
	[key: string]: { name: string; color: TColor };
}

export interface PaymentMethodProp {
	[key: string]: { name: string; color: TColor; paymentMethod: string };
}

export interface OrderEventStatus {
	[key: string]: { name: string; color: TColor; icon: TIcons };
}

export interface SimpleStatus {
	[key: string]: string;
}

/**
 * Hook to get translated status objects
 */
export const useStatus = () => {
	const { t } = useTranslation(['status']);

	const PAYMENT_METHOD: PaymentMethodProp = {
		0: { name: t('PAYMENT_METHOD.0'), color: 'light', paymentMethod: '0' },
		1: { name: t('PAYMENT_METHOD.1'), color: 'dark', paymentMethod: '1' },
		2: { name: t('PAYMENT_METHOD.2'), color: 'success', paymentMethod: '2' },
		3: { name: t('PAYMENT_METHOD.3'), color: 'success', paymentMethod: '3' },
		4: { name: t('PAYMENT_METHOD.4'), color: 'success', paymentMethod: '4' },
		5: { name: t('PAYMENT_METHOD.5'), color: 'success', paymentMethod: '5' },
		6: { name: t('PAYMENT_METHOD.6'), color: 'success', paymentMethod: '6' },
		7: { name: t('PAYMENT_METHOD.7'), color: 'light', paymentMethod: '7' },
		8: { name: t('PAYMENT_METHOD.8'), color: 'light', paymentMethod: '8' },
		9: { name: t('PAYMENT_METHOD.9'), color: 'light', paymentMethod: '9' },
		10: { name: t('PAYMENT_METHOD.10'), color: 'light', paymentMethod: '10' },
		11: { name: t('PAYMENT_METHOD.11'), color: 'dark', paymentMethod: '11' },
		12: { name: t('PAYMENT_METHOD.12'), color: 'success', paymentMethod: '12' },
		13: { name: t('PAYMENT_METHOD.13'), color: 'success', paymentMethod: '13' },
		14: { name: t('PAYMENT_METHOD.14'), color: 'info', paymentMethod: '14' },
		15: { name: t('PAYMENT_METHOD.15'), color: 'light', paymentMethod: '15' },
		16: { name: t('PAYMENT_METHOD.16'), color: 'light', paymentMethod: '16' },
	};

	const INVOICE_STATUS: IEventStatus = {
		0: { name: t('INVOICE_STATUS.0'), color: 'danger' },
		1: { name: t('INVOICE_STATUS.1'), color: 'success' },
		2: { name: t('INVOICE_STATUS.2'), color: 'dark' },
		3: { name: t('INVOICE_STATUS.3'), color: 'danger' },
	};

	const INVOICE_TYPE: SimpleStatus = {
		'0': t('INVOICE_TYPE.0'),
		'1': t('INVOICE_TYPE.1'),
		'2': t('INVOICE_TYPE.2'),
	};

	const INVOICE_CARRIER_TYPE: SimpleStatus = {
		'': t('INVOICE_CARRIER_TYPE.empty'),
		'1': t('INVOICE_CARRIER_TYPE.1'),
		'2': t('INVOICE_CARRIER_TYPE.2'),
		'3': t('INVOICE_CARRIER_TYPE.3'),
	};

	const PAYMENT_STATUS: IEventStatus = {
		0: { name: t('PAYMENT_STATUS.0'), color: 'brand-two' },
		1: { name: t('PAYMENT_STATUS.1'), color: 'brand' },
		2: { name: t('PAYMENT_STATUS.2'), color: 'success' },
		3: { name: t('PAYMENT_STATUS.3'), color: 'primary' },
		4: { name: t('PAYMENT_STATUS.4'), color: 'dark' },
		5: { name: t('PAYMENT_STATUS.5'), color: 'danger' },
		6: { name: t('PAYMENT_STATUS.6'), color: 'info' },
		7: { name: t('PAYMENT_STATUS.7'), color: 'danger' },
		8: { name: t('PAYMENT_STATUS.8'), color: 'danger' },
	};

	const DELIVERY_STATUS: IEventStatus = {
		0: { name: t('DELIVERY_STATUS.0'), color: 'brand-two' },
		1: { name: t('DELIVERY_STATUS.1'), color: 'brand' },
		2: { name: t('DELIVERY_STATUS.2'), color: 'success' },
		3: { name: t('DELIVERY_STATUS.3'), color: 'primary' },
		4: { name: t('DELIVERY_STATUS.4'), color: 'secondary' },
		5: { name: t('DELIVERY_STATUS.5'), color: 'info' },
		6: { name: t('DELIVERY_STATUS.6'), color: 'danger' },
		7: { name: t('DELIVERY_STATUS.7'), color: 'dark' },
		8: { name: t('DELIVERY_STATUS.8'), color: 'warning' },
	};

	const ORDER_STATUS: OrderEventStatus = {
		0: { name: t('ORDER_STATUS.0'), color: 'light', icon: 'AccessTime' },
		1: { name: t('ORDER_STATUS.1'), color: 'primary', icon: 'DirectionsRun' },
		2: { name: t('ORDER_STATUS.2'), color: 'success', icon: 'CheckCircle' },
		3: { name: t('ORDER_STATUS.3'), color: 'dark', icon: 'Cancel' },
		4: { name: t('ORDER_STATUS.4'), color: 'secondary', icon: 'Visibility' },
	};

	return {
		PAYMENT_METHOD,
		INVOICE_STATUS,
		INVOICE_TYPE,
		INVOICE_CARRIER_TYPE,
		PAYMENT_STATUS,
		DELIVERY_STATUS,
		ORDER_STATUS,
	};
};
